import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Calendar Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M2.252 3.75h19.5s1.5 0 1.5 1.5v16.5s0 1.5-1.5 1.5h-19.5s-1.5 0-1.5-1.5V5.25s0-1.5 1.5-1.5M.752 9.75h22.5M6.752 6V.75M17.252 6V.75"
    }, null, -1)
  ]))]))
}
export default { render: render }